module.exports = __webpack_public_path__ + "img/PayPal-App-Activation.4c68ec24.jpg";